export default __webpack_public_path__ + "static/media/FG_43.315189cb.png";